import './animation-height.css'
import { AnimationHeightElement } from './AnimationHeightElement'
customElements.define('animation-height', AnimationHeightElement)
